/* eslint-disable @typescript-eslint/no-magic-numbers */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row, Tag } from 'antd';
import classNames from 'classnames';
import { Header } from 'components/header';
import { LevelsCollapse } from 'components/levels-collapse';
import { useSkillLevelDictionary } from 'hooks/use-skill-levels-dictionary';
import { EpTechnologySkill } from 'types/graphql-types';
import styles from './styles.less';

export type PlatformsFormProps = {
  platforms: EpTechnologySkill[];
};

export const PlatformsView: FC<PlatformsFormProps> = ({ platforms }) => {
  const { t } = useTranslation();
  const { data: levelData } = useSkillLevelDictionary();
  let levels = levelData?.skillLevelList?.slice().reverse() || [];
  let normalizedPlatforms = platforms;
  const emDash = '—';

  if (!platforms.length) {
    normalizedPlatforms = [{ desc: '', level: emDash, name: emDash }];
    levels = [emDash];
  }

  return (
    <Row>
      <Col xs={{ span: 24 }} lg={{ span: 16 }}>
        <Row className={classNames(styles['row'], styles['header-row'])}>
          <Col span={16}>
            <Header level={5} className={styles['header']}>
              {t('Platform name')}
            </Header>
          </Col>
          <Col span={8}>
            <Header level={5} className={styles['header']}>
              {t('Experience')}
            </Header>
          </Col>
        </Row>
        {levels.map((level) => {
          const filteredPlatforms = normalizedPlatforms.filter(
            (plat) => plat.level === level,
          );

          return filteredPlatforms.length > 0 ? (
            <Row
              key={level}
              className={classNames(styles['row'], styles['data-row'])}
            >
              <Col span={16}>
                <Row gutter={[0, 6]}>
                  {filteredPlatforms.length === 1 &&
                  filteredPlatforms[0]?.name === emDash
                    ? emDash
                    : filteredPlatforms.map((platform) => (
                        <Col key={platform.name}>
                          <Tag>{platform.name}</Tag>
                        </Col>
                      ))}
                </Row>
              </Col>
              <Col span={8}>
                <div className={styles['level']}>{level}</div>
              </Col>
            </Row>
          ) : null;
        })}
      </Col>
      <Col xs={{ span: 0 }} lg={{ span: 8 }}>
        <LevelsCollapse />
      </Col>
    </Row>
  );
};
